import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { initialFilter } from '../Data/Constants'
import { selectDriverList } from '../Redux/slices/driverState'
import { selectPartyList, setPartyObj } from '../Redux/slices/partyState'
import { filterResult, selectFilter, selectTransactionsIsLoading } from '../Redux/slices/transactionState'
import { selectVehicleList } from '../Redux/slices/vehicleState'
import GetTimeStamp, { getInputDateString } from '../Utils/GetTimeStamp'
import handleChange from '../Utils/HandleChange'
import { FormInput } from './Controls/Input'
import Select from './Controls/Select'
import GetInputDate from '../Utils/GetInputDate'

export default function FilterBar() {
    const isLoading = useSelector(selectTransactionsIsLoading)
    const parties = useSelector(selectPartyList)
    const drivers = useSelector(selectDriverList)
    const vehicles = useSelector(selectVehicleList)
    const filter = useSelector(selectFilter)
    const FilterFormRef = useRef()
    const [filters, setFilters] = useState(initialFilter)
    const dispatch = useDispatch()
    const changeHandler = handleChange(filters,setFilters)
    const submitHandler = (e)=>{
        e.preventDefault()
        if(filters.date_from) filters.date_from=GetTimeStamp(filters.date_from)
        if(filters.date_to) filters.date_to=GetTimeStamp(filters.date_to)
        dispatch(filterResult(filters))
    }
    const ResetFilter = (e)=>{
        e.preventDefault()
        setFilters({...initialFilter})
        dispatch(filterResult({...initialFilter}))
        FilterFormRef.current.reset()
    }
    const PartyChangeHandler = (e)=>{
        e.preventDefault();
        setFilters({...filters,party:e})
        dispatch(setPartyObj())
    }
    return (
        <form ref={FilterFormRef} className='px-8 pb-3 bg-gray-100 flex flex-wrap justify-between items-start rounded-lg shadow-md border pt-6'>
            <div className='w-full lg:w-1/2 flex flex-wrap justify-between items-center'>
                <Select name='party' label='Party' placeholder='Filter By party' defaultValue={filter.party}  options={parties} onChange={changeHandler} />
                <Select name='driver' label='Driver' placeholder='Filter By driver' defaultValue={filter.driver} options={drivers} onChange={changeHandler} />
                

            </div>
            <div className='w-full lg:w-1/2 flex flex-wrap justify-between items-center'>
                <FormInput name='date_from' type='date' label='From' defaultValue={GetInputDate(filter.date_from)} onChange={changeHandler}/>
                <FormInput name='date_to' type='date' label='To' defaultValue={GetInputDate(filter.date_to)} onChange={changeHandler} />
            </div>
            <div className='w-full lg:w-1/2 flex flex-wrap justify-between items-center'>
                <Select name='vehicle' label='Vehicle' options={vehicles} placeholder='Filter By Vehicle' defaultValue={filter.vehicle} onChange={changeHandler} />
                <FormInput name='limit_no' type='number' min="50" label='Records Limit' placeholder='No of Records to show' defaultValue={filter.limit_no} onChange={changeHandler} />
            </div>
            <div className='w-full lg:w-1/2 flex flex-wrap items-center pt-9'>
                
                <button onClick={submitHandler} className='p-3 mb-5 bg-blue-500 rounded-md text-white font-medium mx-4'>{isLoading?'Loading...':'Filter Result'}</button>
                <button onClick={ResetFilter} className='p-3 mb-5 bg-gray-500 rounded-md text-white font-medium ml-4'>Reset all</button>
            </div>

        </form>
    )
}
